import React from 'react';
import { useMediaQuery } from 'react-responsive';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

// import { clsx } from 'clsx';
// import { twMerge } from 'tailwind-merge';

// export function cn(...inputs) {
//   return twMerge(clsx(inputs));
// }

const twConfig = resolveConfig(tailwindConfig);

export const randomId = () => {
  return Math.random().toString(32).slice(2);
};

export const devOrProd = process.env.REACT_APP_DEVORPROD;
export const devOrProdFeeds = process.env.REACT_APP_DEVORPROD;
export const nuqliumDataIndexSevenFeeds = () => {
  if (devOrProdFeeds === 'dev') {
    return '100042';
  }
  if (devOrProdFeeds === 'prod') {
    return '100052';
  }
};

export const nuqliumDataIndexSeven = () => {
  if (devOrProd === 'dev') {
    return '100042';
  }
  if (devOrProd === 'prod') {
    return '100052';
  }
};

export const getCookieValue = (a) => {
  var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
};

export const ppHeadingOverridesOpen = () => {
  // Header overrides
  const headerElement = document.querySelector('header');
  headerElement.classList.add('header-override');
  // Main overrides
  const mainElement = document.querySelector('.main');
  mainElement.classList.add('main-override');
  // Nav overrides
  document.getElementById('nav-level0').classList.add('nav-level0-override');
};

export const ppHeadingOverridesClose = () => {
  // Header overrides
  const headerElement = document.querySelector('header');
  headerElement.classList.remove('header-override');
  // Main overrides
  const mainElement = document.querySelector('.main');
  mainElement.classList.remove('main-override');
  // Nav overrides
  document.getElementById('nav-level0').classList.remove('nav-level0-override');
};

export const ppPopupOverridesClose = () => {
  // Body overrides
  const bodyElement = document.querySelector('body');
  bodyElement.classList.remove('popwindow');
};

export const checkForColour = (data) => {
  if (data.colour) {
    return data.colour[0].toLowerCase();
  }
  if (data.facolour) {
    return data.facolour[0].toLowerCase();
  }
};

export const swapImg = (imgPath, fromSize, toSize) => {
  return imgPath.replace(fromSize, toSize);
};

export const brandUrl = (brandName) => {
  return (
    brandName
      // Breaking up '.replace' for easier reading
      .replace(/\s+/g, '-') // Replace space(s) with hyphen
      .replace(/\.|&/g, '') // Remove '.' / '&' symbol
      .replace(/\\-\\-+/g, '-') // Replace multiple hyphen's with one
      .replace(/(^-+|-+$)/g, '') // Remove extra hyphen from beginning / end
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/\+/g, '--') // Replace '+' with '--'
      .toLowerCase()
  );
};

export const getPercentPrice = (data) => {
  const diff = data.option.priceasnumber - data.option.promotionpriceasnumber;
  return Math.floor((diff / data.option.priceasnumber) * 100);
};

const getDiscountAmount = (data) => {
  const differnce =
    data.option.priceasnumber - data.option.promotionpriceasnumber;
  return differnce;
};

const getCurrencySymbol = () => {
  return getCookieValue('currencypref') === 'GBP'
    ? '£'
    : getCookieValue('currencypref') === 'USD' ||
      getCookieValue('currencypref') === 'AUD' ||
      getCookieValue('currencypref') === 'HKD'
    ? '$'
    : getCookieValue('currencypref') === 'EUR'
    ? '€'
    : getCookieValue('currencypref') === 'CNY' ||
      getCookieValue('currencypref') === 'JPY'
    ? '¥'
    : '£';
};

export const calculateSaleDiscount = (data) => {
  let locale;
  /*
  const getCurrencySymbol = data.option.price.match(/^[^\d]+/)[0];
  switch (getCurrencySymbol) {
    case '£':
      locale = 'en-GB';
      break;
    case '€':
      locale = 'en-EU';
      break;
    case '$':
      locale = 'en-US';
      break;
    case '¥':
      locale = 'ja-JP';
      break;
    case 'AUD':
      locale = 'en-AU';
      break;
    default:
      locale = 'en-GB';
  }
  */

  const discountAmount = getDiscountAmount(data);
  const formattedAmount = discountAmount.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return `${getCurrencySymbol()}${formattedAmount}`;
};

export const getFormData = (object) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
};

export const renderHTML = (rawHTML, className = null) => {
  // Render HTML in JSON
  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: rawHTML }} />
  );
};

export const renderHTMLspan = (rawHTML, className = null) => {
  // Render HTML in JSON
  return (
    <span className={className} dangerouslySetInnerHTML={{ __html: rawHTML }} />
  );
};

export const checkImgPath = (currentPath) => {
  return currentPath.includes('medium')
    ? currentPath.replace('medium', 'medium')
    : currentPath;
};

// Return the correct price
export const checkProdPrice = (currentProd) => {
  if (getCookieValue('currencypref') === 'GDP') {
    //console.log(currentProd.prodPrice);
    if (currentProd.prodPrice) {
      return currentProd.prodPrice;
    }
    //console.log(currentProd.prodNowPrice);
    if (currentProd.prodNowPrice) {
      return renderHTML(currentProd.prodNowPrice);
    } else {
      return '\u00A0';
    }
  }
  if (getCookieValue('currencypref') === 'EUR') {
    if (getCookieValue('countrypref1') === 'IE') {
      return currentProd.prodPriceIe !== 'undefined'
        ? renderHTML(decodeURIComponent(currentProd.prodPriceIe))
        : '\u00A0';
    }
    if (
      getCookieValue('countrypref1') === 'FR' ||
      getCookieValue('countrypref1') === 'DE' ||
      getCookieValue('countrypref1') === 'ES' ||
      getCookieValue('countrypref1') === 'PL' ||
      getCookieValue('countrypref1') === 'PT' ||
      getCookieValue('countrypref1') === 'AT' ||
      getCookieValue('countrypref1') === 'DK' ||
      getCookieValue('countrypref1') === 'LU' ||
      getCookieValue('countrypref1') === 'SE'
    ) {
      return currentProd.prodPriceEuPlus !== 'undefined'
        ? renderHTML(decodeURIComponent(currentProd.prodPriceEuPlus))
        : '\u00A0';
    }
    if (getCookieValue('countrypref1') !== 'IE') {
      return currentProd.prodPriceEuDef !== 'undefined'
        ? renderHTML(decodeURIComponent(currentProd.prodPriceEuDef))
        : '\u00A0';
    }
  }
  if (getCookieValue('currencypref') === 'USD') {
    return currentProd.prodPriceUs !== 'undefined' &&
      currentProd.prodCat !== 'Nike'
      ? renderHTML(decodeURIComponent(currentProd.prodPriceUs))
      : '\u00A0';
  }
  if (getCookieValue('currencypref') === 'AUD') {
    return currentProd.prodPriceAu !== 'undefined'
      ? renderHTML(decodeURIComponent(currentProd.prodPriceAu))
      : '\u00A0';
  }
  if (getCookieValue('currencypref') === 'CNY') {
    return currentProd.prodPriceCh !== 'undefined'
      ? renderHTML(decodeURIComponent(currentProd.prodPriceCh))
      : '\u00A0';
  }
  if (getCookieValue('currencypref') === 'HKD') {
    return currentProd.prodPriceHd !== 'undefined'
      ? renderHTML(decodeURIComponent(currentProd.prodPriceHd))
      : '\u00A0';
  }
  if (getCookieValue('currencypref') === 'JPY') {
    return currentProd.prodPriceHd !== 'undefined'
      ? renderHTML(decodeURIComponent(currentProd.prodPriceJp))
      : '\u00A0';
  } else {
    if (currentProd.prodPrice) {
      return currentProd.prodPrice;
    }
    if (currentProd.prodNowPrice) {
      return renderHTML(currentProd.prodNowPrice);
    } else {
      return '\u00A0';
    }
  }
};

export const getInternationalPriceNuqlium = () => {
  if (window?.nqDataLayer?.pricelist) return window.nqDataLayer.pricelist;
  else return 'retail_gbp';
  /*
  switch (getCookieValue('currencypref')) {
    case 'GBP':
      return 'retail_gbp';
    case 'EUR':
      return 'retail_eur';
    case 'USD':
      return 'retail_usd';
    case 'AUD':
      return 'retail_aud';
    case 'JPY':
      return 'retail_jpy';
    case 'CNY':
      return 'retail_cny';
    case 'HKD':
      return 'retail_hkd';
    default:
      return 'retail_gbp';
  }
  */
};

export const randomString = () => {
  return Math.random().toString(36).substring(7);
};

export const getBreakpoint = (query) => {
  return parseInt(twConfig.theme.screens[query].replace('px', ''));
};

export const getPreviousBreakpoint = (query) => {
  const keys = Object.keys(twConfig.theme.screens);
  if (query === 'sm') return 0;
  const prevBreakpoint = keys[keys.indexOf(query) - 1];
  return getBreakpoint(prevBreakpoint);
};

export const getNextBreakpoint = (query) => {
  const keys = Object.keys(twConfig.theme.screens);
  const nextBreakpoint = keys[keys.indexOf(query) + 1];
  return getBreakpoint(nextBreakpoint);
};

export const useTailwindMediaQuery = (query) => {
  const breakpoint = getBreakpoint(query);

  return useMediaQuery({ maxWidth: breakpoint });
};

// The polling function
export const poll = (fn, timeout, interval) => {
  let endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  let checkCondition = (resolve, reject) => {
    // If the condition is met, we're done!
    let result = fn();
    if (result) {
      resolve(result);
    }
    // If the condition isn't met but the timeout hasn't elapsed, go again
    else if (Number(new Date()) < endTime) {
      setTimeout(
        () => {
          checkCondition(resolve, reject);
        },
        interval,
        resolve,
        reject
      );
    }
    // Didn't match and too much time, reject!
    else {
      reject(new Error('Timed out'));
    }
  };

  return new Promise(checkCondition);
};

export const isAppExclusive = (data) => {
  if (data && data.product !== null) {
    const exclusiveBrands = ['Gramicci'];

    return exclusiveBrands.includes(data.product.attributes.brand[0]);
  }
};
